/**
 * Direct links for ads: query params that open a modal on arrival.
 *
 *   /?signup=1                          signup modal
 *   /?login=1                           login modal
 *   /?discovery=1                       discovery-call booking modal
 *   /pricing?plan=pro_plan&cycle=6-month  that plan's checkout (login first if needed)
 *
 * takeDeepLinkParams() reads the given keys and removes only those from the
 * address bar, so UTMs and fbclid stay (attribution reads them on the same
 * load) and a refresh doesn't reopen the modal.
 */
export const takeDeepLinkParams = (keys) => {
  const found = {};
  try {
    const url = new URL(window.location.href);
    keys.forEach((key) => {
      const value = url.searchParams.get(key);
      if (value !== null) {
        found[key] = value;
        url.searchParams.delete(key);
      }
    });
    if (Object.keys(found).length) {
      window.history.replaceState(window.history.state, document.title, url.pathname + url.search + url.hash);
    }
  } catch (e) {
    // unreadable URL: no deep link
  }
  return found;
};

/** 'monthly' or '6-month' (the Pricing toggle values), or null. */
export const normaliseCycle = (cycle) => {
  const value = String(cycle || '').toLowerCase().replace(/[\s_]/g, '-');
  if (['monthly', 'month', '1-month', '1'].includes(value)) return 'monthly';
  if (['6-month', '6-months', '6month', 'six-month', 'half-yearly', '6'].includes(value)) return '6-month';
  return null;
};
